export interface SuggestedProfileDefaults {
  countryCode?: string;
  formattingLocale?: string;
  timeZone?: string;
}

export function getSuggestedProfileDefaults(): SuggestedProfileDefaults {
  const formattingLocale = navigator.language || "en-US";
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  let countryCode: string | undefined;
  try {
    countryCode = new Intl.Locale(formattingLocale).region;
  } catch {
    countryCode = undefined;
  }
  return {
    ...(countryCode === undefined ? {} : { countryCode }),
    ...(formattingLocale ? { formattingLocale } : {}),
    ...(timeZone ? { timeZone } : {}),
  };
}
